import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { CircularGaugeComponent } from '@syncfusion/ej2-angular-circulargauge';
import { Subject, combineLatest, takeUntil, distinctUntilChanged, filter, interval } from 'rxjs';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { MatMenu } from '@angular/material/menu';
import { PanelData } from '../custom-dashboard/custom-dashboard.component';

@Component({
	selector: 'app-dashboard-text',
	templateUrl: './dashboard-text.component.html',
	styleUrls: ['./dashboard-text.component.scss']
})
export class DashboardTextComponent implements OnInit, OnDestroy {

	/** Observable Subject Finalise */
	private finalise = new Subject<void>();

	/** panelData */
	@Input() panelData: any;

	/** publicPanelData */
	@Input() publicPanelData: PanelData[];

	/** creating */
	@Input() creating: boolean;

	/** titleMenu */
	@Input() titleMenu: MatMenu;

	/** intervalFinish */
	@Output() intervalFinish = new EventEmitter<any>();

	/** Page Refresh Interval object */
	private refreshInterval: any;

	/** refreshTime */
	private refreshTime: number = 0.5;

	constructor(
		public globalFunctions: GlobalFunctions,
		private siteSubscriptions: siteSubscriptions,
		@Inject(DOCUMENT) public document: Document,
		private vcr: ViewContainerRef
	) {
		/** Get required subscriptions */
		combineLatest([
			this.siteSubscriptions.selectedOrganisation$.pipe(takeUntil(this.finalise), distinctUntilChanged()),
		]).pipe(
			// Ensure that subscriptions are not null or undefined
			filter(([selectedAccount]) => !!selectedAccount)
		).subscribe({
			next: ([selectedAccount]) => {
			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
			}
		});
	}	

	/**
	 * ngOnInit
	 */
	ngOnInit(): void {
		this.refreshInterval = interval((this.refreshTime * 60000)).pipe(takeUntil(this.finalise)).subscribe(() => {
			this.intervalFinish.emit(this.panelData);
		});
	}

	/**
	 * ngOnDestroy
	 */
	ngOnDestroy(): void {
		this.finalise.next();
		this.finalise.complete();
		if (this.refreshInterval) {
			clearInterval(this.refreshInterval);  // Clear the interval if it's set
			this.refreshInterval = null;  // Reset to null to prevent memory leaks
		}
	}
}
